<template>
<tr>
    <td>
        <div class="form-group mb-0">
            <div class="form-check">
                <input
                    class="form-check-input form-check-input-radio form-check-input-radio2"
                    name="card_default"
                    type="radio"
                    :id="`card-${payment.id}`"
                    :value="1"
                    v-model="payment.is_default"
                    @change="setDefault(payment.id)"
                >
                <label class="form-check-label" :for="`card-${payment.id}`"></label>
            </div>
        </div>
    </td>
    <td class="card-holder-name">
        <p>{{ card_full_name }}</p>
        <div class="card-info">
            <img :src="`/img/${payment.card_type}.png`" alt="" class="card-img">
            <div class="hold">
                <span class="card-num"> ****   {{ payment.card_number.toString().slice(-4) }}</span>
                <span class="date">{{ payment.card_expiration_month < 10 ?  '0' + payment.card_expiration_month : payment.card_expiration_month }}/{{ payment.card_expiration_year.substr(-2) }}</span>
            </div>
        </div>
    </td>
    <td>
        {{ payment.billing_email }}<br>
        {{ payment.billing_phone }}<br>
        {{ payment.billing_street }}<br>
        {{ payment.billing_city.ucfirst() }}, {{ payment.state ? payment.state.code : '' }} {{ payment.billing_zip_code }}, {{ payment.country ? payment.country.code : '' }}
    </td>
    <td class="text-center action-block">
        <a :href="`/subscription/my-payment-method/${payment.id}/edit`" class="action"><i class="fas fa-pencil-alt mr-4"></i></a>
        <a href="javascript:void(0)" class="action delete" @click="deletePayment(payment.id)"><i class="fas fa-times"></i></a>
    </td>
</tr>
</template>

<script>
    export default {
        name: "PaymentCardBillingItem",
        props: {
            input_payment: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                payment: this.input_payment
            }
        },
        computed: {
            card_full_name() {
                return `${this.payment.card_first_name} ${this.payment.card_last_name}`.ucwords();
            },
            billing_full_name() {
                return `${this.payment.billing_first_name} ${this.payment.billing_last_name}`.ucwords();
            }
        },
        methods: {
            deletePayment(id) {
                this.$emit('destroy', id);
            },
            setDefault(id) {
                this.$emit('set-default', id);
            }
        }
    }
</script>
